export default __webpack_public_path__ + "static/small-10-3b4844f93d8e655bcf27ffb7e99bb834.png";